import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=dcc7be9e&lang=pug"
import script from "./PostForm.vue?vue&type=script&lang=ts"
export * from "./PostForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports